// extracted by mini-css-extract-plugin
export default {"container":"copyTextBtn_container__mCiV0","copyIcon":"copyTextBtn_copyIcon__mKq1o"};